import { useEffect, useState, useRef, useMemo } from "react"
import { formatPhone } from "../../../../utils/format"
import { useNavigate } from "react-router-dom"
import TrashSVG from "../../../icons/trash"

import Button from "../../../button/button"
import Select from "../../../select/select"
import TableCstmPs from "../../../TableCstmPs/TableCstmPs"

import "./TeachersFollowUp.scss"
import TFollowUpAdd from "./TFollowUpAdd/TFollowUpAdd"
import { GetAllReceptionistBySubsidiaryOrAllTeachersByReceptionistInCharge, GetAllTeacherThatIsInChargeReceptionistByEmployeeId } from "../../../../utils/Apis/principalApis"
import { GetAllReceptionistWithTheirTeacherInChargeBySubsidiary, PatchRemoveTeacherRelFromReceptionist } from "../../../../utils/Apis/receptionApis"
import EmptyMessage from "../../../EmptyMessage/emptyMessage"
import ConfirmModal from "../../../ConfirmModalV3/confirmModal"
import Alert from "../../../alert/Alert"
import Autocomplete from "../../../../DesignSystem/Molecules/Autocomplete/Autocomplete"
import AssignmentsList from "./AssignmentsList/AssignmentsList"
import { use } from "react"
import LoadingComponent from "../../../loading/LoadingComponent/loadingComponent"
const TeachersFollowUp = ({ isOpen, usr, listSubsidiary }) => {
    const navigate = useNavigate();

    const [isTFAddOpen, setIsTFAddOpen] = useState(false);
    const [subsidiaryState, setSubsidiaryState] = useState([]);
    const [scopeFilter, setScopeFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingTableRecep, setLoadingTableRecep] = useState(false);
    const [error, setError] = useState(null);

    const [disabledButtonModal, setDisabledButtonModal] = useState(false)

    const [ReceptionistOrTeacherListState, setReceptionistOrTeacherListState] = useState([])
    const employeeIdState = usr?.employee_id;
    const employeePrivilage = usr?.idPriv;
    const employeeSubPrivilage = usr?.fk_sub_privilege;

    const [teacherArrayToShowTable, setTeacherArrayToShowTable] = useState([])
    const [receptionistSelected, setReceptionistSelected] = useState({})
    const [receptionistDataWithTheirTeachersToShowTable, setReceptionistDataWithTheirTeachersToShowTable] = useState([]);

    const cacheTeacherList = useRef({}); // 🔄 Caché por plantel
    const cacheTeacherGroupsList = useRef({}); // 🔄 Caché por maestro (grupos)
    const cacheReceptionistWithTheirTeacher = useRef({}); // 🔄 Caché por recepcionista (tabla de maestros que cada recepcionista se encarga)

    const [disableAutoComplete, setDisableAutoComplete] = useState(false)

    const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
    const [modalDetailAction, setModalDetailAction] = useState('')
    const [modalTitleAction, setModalTitleAction] = useState('')
    const canDoMovements =
        parseInt(employeePrivilage) === parseInt(process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE) ||
        parseInt(employeeSubPrivilage) === parseInt(process.env.REACT_APP_API_SUB_PRIVILEGE_INCHARGE);
    const [modalHandlers, setModalHandlers] = useState({
        handleAccept: () => { },
        handleCancel: () => { },
    });
    ////Alert
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])

    //
    const exampleData = [
        {
            id: "R1",
            name: "Jessica",
            phone: "6642221960",
            email: "jessica@escuela.com",
            subsidiary: "Plaza Estrella",

            totalStudents: 72,

            teachers: [
                {
                    id: "T1",
                    name: "Alef",
                },
                {
                    id: "T2",
                    name: "Abel",
                },
                {
                    id: "T3",
                    name: "Katherine",
                },
            ],
        },
    ]
    //
    useEffect(() => {
        // 1. Validamos si ya existe el elemento para evitar duplicados
        const yaExiste = listSubsidiary.some(item => item.value === 0);

        if (!yaExiste) {
            // 2. Creamos una nueva lista con el elemento al inicio y el resto después
            const nuevaLista = [{ value: 'mine', label: 'Mis Maestros' }, ...listSubsidiary];

            // 3. Actualizamos el estado (asumiendo que tienes un setListSubsidiary)
            setSubsidiaryState(nuevaLista);
        }
    }, [listSubsidiary]); // Se ejecutará cuando la lista original cambie

    const fetchTeacherData = async () => {
        try {
            setLoading(true);
            setError(null);

            if (scopeFilter in cacheTeacherList.current) {
                setReceptionistOrTeacherListState(
                    cacheTeacherList.current[scopeFilter]
                );
                setLoading(false)

                return;
            }

            const isbyReceptionistInCharge =
                scopeFilter === "mine";

            const teacherListResponse =
                await GetAllReceptionistBySubsidiaryOrAllTeachersByReceptionistInCharge(
                    employeeIdState,
                    scopeFilter,
                    isbyReceptionistInCharge
                );

            if (teacherListResponse.auth === false) {
                navigate("/login");
                return;
            }

            const formattedList = teacherListResponse.result.map((v) => ({
                employee_id: v.employee_id,
                name: v.name,
                contact: {
                    email: v.email,
                    phone: v.phone_number
                },
                ...(isbyReceptionistInCharge && {
                    total_students: v.total_students
                })
            }));

            cacheTeacherList.current[scopeFilter] =
                formattedList;

            setReceptionistOrTeacherListState(
                formattedList
            );
            setLoading(false)


            setTeacherArrayToShowTable([]);

        } catch (err) {

            setError("Error al cargar los maestros");

        } finally {

            setLoading(false);

        }
    };

    const fetchReceptionistDataForTable = async () => {
        try {
            setLoadingTableRecep(true);
            setError(null);

            if (scopeFilter in cacheReceptionistWithTheirTeacher.current) {
                setReceptionistDataWithTheirTeachersToShowTable(cacheReceptionistWithTheirTeacher.current[scopeFilter])
                setLoadingTableRecep(false)

                return;
            }

            const isbyReceptionistInCharge =
                scopeFilter === "mine";

            if (isbyReceptionistInCharge) return

            const receptionistListResponse = await GetAllReceptionistWithTheirTeacherInChargeBySubsidiary(scopeFilter);

            if (receptionistListResponse.auth === false) {
                navigate("/login");
                return;
            }

            if (receptionistListResponse.status !== 200) {
                setReceptionistDataWithTheirTeachersToShowTable(receptionistListResponse.response)
                setLoadingTableRecep(false)
                return;
            }
            let obj = receptionistListResponse.response
            cacheReceptionistWithTheirTeacher.current[scopeFilter] = obj;
            setReceptionistDataWithTheirTeachersToShowTable(obj)
            setLoadingTableRecep(false)
        } catch (err) {

            setError("Error al cargar los recepcionistas");

        } finally {

            setLoadingTableRecep(false);

        }
    }

    const fetchTeacherGroups = async (employee_id) => {
        try {

            setLoading(true);
            setError(null);

            if (employee_id in cacheTeacherGroupsList.current) {

                setTeacherArrayToShowTable(
                    cacheTeacherGroupsList.current[employee_id]
                );
                setLoading(false)
                return;
            }

            const teacherGroupsResponse =
                await GetAllTeacherThatIsInChargeReceptionistByEmployeeId(
                    employee_id
                );

            if (teacherGroupsResponse.auth === false) {
                navigate("/login");
                return;
            }

            const formattedList =
                teacherGroupsResponse.response.map((v) => ({
                    employee_id: v.employee_id,
                    name: v.name,
                    contact: {
                        email: v.email,
                        phone: v.phone_number
                    },
                    total_students: v.total_students
                }));

            cacheTeacherGroupsList.current[employee_id] =
                formattedList;

            setTeacherArrayToShowTable(formattedList);
            setLoading(false)

        } catch (err) {

            setError(
                "Error al cargar los grupos del maestro"
            );

        } finally {

            setLoading(false);

        }
    };
    useEffect(() => {

        if (!scopeFilter || !employeeIdState) return;

        setReceptionistSelected({});
        setDisableAutoComplete(scopeFilter === "mine");

        fetchTeacherData();

    }, [scopeFilter, employeeIdState]);
    useEffect(() => {

        if (!scopeFilter) return;
        if (scopeFilter === 'mine') return;
        fetchReceptionistDataForTable();

    }, [scopeFilter]);

    useEffect(() => {

        if (!receptionistSelected?.employee_id) return;

        fetchTeacherGroups(
            receptionistSelected.employee_id
        );

    }, [receptionistSelected]);

    const refreshTeacherData = async () => {

        // invalidar cache actual

        delete cacheTeacherList.current[scopeFilter];

        if (receptionistSelected?.employee_id) {
            delete cacheTeacherGroupsList.current[
                receptionistSelected.employee_id
            ];
        }

        if (scopeFilter === "mine") {

            await fetchTeacherData();

        } else if (receptionistSelected?.employee_id) {

            await fetchTeacherGroups(
                receptionistSelected.employee_id
            );
        }
    };

    const columns = [

        {
            header: "Maestro",

            accessor: "name",

            className: "tableCtype4",
        },

        {
            header: "Teléfono",

            accessor: "contact.phone",

            className: "tableCtype3",

            render: (value) => formatPhone(value),
        },

        {
            header: "Estudiantes activos",

            accessor: "total_students",

            className: "tableCtype1",
        },

        ...(canDoMovements
            ? [{
                header: "",
                id: "actions",
                className: "tableCtype0",
                render: (_, teacher) => (
                    <Button
                        Icon={TrashSVG}
                        backgroundColor="transparent"
                        onClick={() => handleDeleteTeacher(teacher)}
                    />
                ),
            }]
            : [])
    ];
    // ──────────────────────────────────────────────
    // 🚗 HANDLERS
    // ──────────────────────────────────────────────

    const handleDeleteTeacher = async (teacher) => {
        try {

            const receptionistEmployeeId =
                scopeFilter === "mine"
                    ? employeeIdState
                    : receptionistSelected.employee_id;

            const confirm = await ConfirmAction();

            if (!confirm) return;

            const response = await PatchRemoveTeacherRelFromReceptionist(
                receptionistEmployeeId,
                teacher.employee_id
            );

            if (response.status !== 200) {
                setDisabledButtonModal(false);
                return;
            }
            showAlert('success', response.message)
            await refreshTeacherData();

        } catch (error) {
            console.error(error);
        } finally {
            setDisabledButtonModal(false);
        }
    };
    const handleTAddOpen = () => {
        setIsTFAddOpen(true);
    }
    const handleTAddClose = () => {
        setIsTFAddOpen(false);
    }
    const handleScopeFilter = async (value) => {

        setScopeFilter(value)
        // Limpiar selección actual
        setReceptionistSelected({});

        // Limpiar tabla
        setTeacherArrayToShowTable([]);
    }

    // Función para construir el nombre completo
    const getFullName = (teacher) => {
        return `${teacher.name}`;
    };

    const handleTeacherChange = (value) => {
        if (value === null) {
            setReceptionistSelected({})
            return

        }
        setReceptionistSelected(value)
        setTeacherArrayToShowTable([]);
    }

    /////////////////////////////////////////////
    const ConfirmAction = () => {
        return new Promise((resolve) => {

            setIsModalConfirmOpen(true); // Abre el modal
            setModalTitleAction('Eliminar asignación de maestro')
            setModalDetailAction('¿Seguro desea des asignar al maestro del recepcionista?')
            // Pasas estas funciones al modal para controlar los botones
            const handleAccept = () => {
                // setDisableAll(true)
                setIsModalConfirmOpen(false); // Cierra el modal
                resolve(true); // Resuelve la promesa con "true" si acepta
                setDisabledButtonModal(true)

            };

            const handleCancel = () => {
                setIsModalConfirmOpen(false); // Cierra el modal
                resolve(false); // Resuelve la promesa con "false" si cancela
            };

            // Almacenar funciones en el estado para pasar al modal
            setModalHandlers({ handleAccept, handleCancel });
        });
    };

    const totalStudents = useMemo(() => {
        const data =
            scopeFilter === "mine"
                ? ReceptionistOrTeacherListState
                : teacherArrayToShowTable;

        return data.reduce(
            (acc, teacher) => acc + (teacher.total_students || 0),
            0
        );
    }, [
        scopeFilter,
        ReceptionistOrTeacherListState,
        teacherArrayToShowTable
    ]);

    // Función auxiliar para mostrar alertas
    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts(oldArray => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };
    return (
        <>
            <div className="teachers-follow-up-container main-color">
                <div className="t-followup-info-container">
                    <div className="t-follow-up-header">

                        <div>
                            <h1 className="title-1">
                                Seguimiento de maestros
                            </h1>

                            <h1 className="title-1 title-special">
                                por recepcionista
                            </h1>
                        </div>

                        <div className="follow-up-filter-container">

                            <Select
                                options={subsidiaryState}
                                onChange={(e) => handleScopeFilter(e.target.value)}
                                placeholder={'Selecciona Sucursal / Mis maestros'}
                                value={scopeFilter}
                            />
                            <Autocomplete
                                options={ReceptionistOrTeacherListState}// Pasa los objetos completos como opciones 
                                placeholder={"Busca al recepcionista"}
                                getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
                                isOptionEqualToValue={(option, value) => option.employee_id === value.employee_id} // Comparación basada en el 'id'
                                disabled={disableAutoComplete}
                                onChange={(value) => handleTeacherChange(value)}
                                value={
                                    Object.keys(receptionistSelected).length !== 0 ? ReceptionistOrTeacherListState.find(t => t.employee_id === receptionistSelected.employee_id) : ''
                                } // Aquí pasas el objeto completo
                            />
                            {
                                canDoMovements && (
                                    <Button
                                        text={"Asignar maestro"}
                                        onClick={handleTAddOpen}
                                        disabled={
                                            !scopeFilter ||
                                            (scopeFilter !== 'mine' && !receptionistSelected?.employee_id)
                                        }
                                    />
                                )
                            }

                        </div>

                    </div>
                    <div className="t-followup-table-container"> {/* NUEVO DIV */}

                        {
                            !scopeFilter ? (
                                <EmptyMessage text="Selecciona un filtro" />
                            ) : scopeFilter !== 'mine' && Object.keys(receptionistSelected).length === 0 ? (
                                <EmptyMessage text="Selecciona un recepcionista" />
                            ) : (
                                loading ?
                                    <LoadingComponent text={'Cargando...'}
                                    />
                                    :
                                    <>
                                        {(
                                            (scopeFilter === 'mine' && ReceptionistOrTeacherListState.length > 0) ||
                                            (scopeFilter !== 'mine' && teacherArrayToShowTable.length > 0)
                                        ) ? (
                                            <>
                                                <TableCstmPs
                                                    columns={columns}
                                                    data={
                                                        scopeFilter === 'mine'
                                                            ? ReceptionistOrTeacherListState
                                                            : teacherArrayToShowTable
                                                    }
                                                    className="t-followup-table"
                                                    variant="modern"
                                                    styleOptions={{
                                                        striped: false,
                                                        hoverable: true,
                                                        rounded: true,
                                                        shadow: true,
                                                    }}
                                                    layout={{
                                                        borderMode: "separate",
                                                    }}
                                                />

                                                <div>
                                                    <h1 className="emphasis-2">
                                                        Total de estudiantes: {totalStudents}
                                                    </h1>
                                                </div>
                                            </>
                                        ) : (
                                            <EmptyMessage text="No se encontraron maestros" />
                                        )}
                                    </>
                            )
                        }
                    </div>
                </div>
                <div className="t-fup-assignment-list-section">{/* NUEVO DIV */}
                    {
                        loadingTableRecep ?
                            <LoadingComponent text={'Cargando...'}
                            />
                            :
                            <AssignmentsList
                                assignments={receptionistDataWithTheirTeachersToShowTable}
                            />
                    }
                </div>
            </div>
            <ConfirmModal
                isOpen={isModalConfirmOpen}
                handleAccept={modalHandlers.handleAccept}
                handleCancel={modalHandlers.handleCancel}
                text={modalDetailAction}
                title={modalTitleAction}
                disabled={disabledButtonModal}
            />
            <div className="divAlert">
                <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
            </div>
            {isTFAddOpen && <TFollowUpAdd showAlert={showAlert} refreshData={refreshTeacherData} isOpen={isTFAddOpen} onClose={handleTAddClose} listSubsidiary={listSubsidiary} employee_id={(!receptionistSelected?.employee_id) ? employeeIdState : receptionistSelected?.employee_id} cacheTeacherGroupsList={cacheTeacherGroupsList} cacheTeacherListFollowUpMain={cacheTeacherList} />}
        </>
    );
};

export default TeachersFollowUp;
